import { z } from 'zod'
import {
  CRM_ACTIVITY_CONTRACT_VERSION,
  CRM_ACTIVITY_ERROR_CODES,
  crmActivitySummarySchema,
} from './crm-activity-read'

/**
 * Transport request contracts keep the same field surface the CRM activity
 * handlers accept today (lead id aliases, type aliases, body aliases). Domain
 * validation stays in the route validators so existing 400 messages are unchanged.
 */
export const crmActivityCreateRequestSchema = z.object({
  leadId: z.unknown().optional(),
  lead_id: z.unknown().optional(),
  type: z.unknown().optional(),
  activityType: z.unknown().optional(),
  activity_type: z.unknown().optional(),
  body: z.unknown().optional(),
  content: z.unknown().optional(),
  note: z.unknown().optional(),
  description: z.unknown().optional(),
  occurredAt: z.unknown().optional(),
  occurred_at: z.unknown().optional(),
  assigneeUserId: z.unknown().optional(),
  assignee_user_id: z.unknown().optional(),
}).passthrough()

const crmActivityWriteSideEffectsSchema = z.object({
  db1Written: z.boolean(),
  auditWritten: z.boolean(),
  billingTouched: z.literal(false),
  eventEmitted: z.literal(false),
  uploadTouched: z.literal(false),
  llmTouched: z.literal(false),
  queuePublished: z.literal(false),
  db2Touched: z.literal(false),
  deployLiveTraffic: z.literal(false),
  destructiveCleanup: z.literal(false),
}).passthrough()

export const crmActivityCreateResponseSchema = z.object({
  contract_version: z.literal(CRM_ACTIVITY_CONTRACT_VERSION),
  activity: crmActivitySummarySchema,
  sideEffects: crmActivityWriteSideEffectsSchema,
}).passthrough()

export const CRM_ACTIVITY_WRITE_ERROR_CODES = CRM_ACTIVITY_ERROR_CODES

export const crmActivityWriteErrorEnvelopeSchema = z.object({
  contract_version: z.string().min(1),
  error: z.object({
    code: z.enum(CRM_ACTIVITY_WRITE_ERROR_CODES),
    message: z.string().min(1),
    reference: z.string().min(1),
    details: z.record(z.unknown()).optional(),
    request_id: z.string().optional(),
  }).passthrough(),
}).passthrough()

export type CrmActivityCreateRequest = z.infer<typeof crmActivityCreateRequestSchema>
export type CrmActivityCreateResponse = z.infer<typeof crmActivityCreateResponseSchema>
export type CrmActivityWriteErrorEnvelope = z.infer<typeof crmActivityWriteErrorEnvelopeSchema>
export { crmActivitySummarySchema }
